import React, { Component } from "react";
import {
  Container,
  Button,
  ModalFooter,
  ModalBody
} from "reactstrap";


export default class ConfirmPrintRoll extends Component {
  constructor(props) {
    super(props);
    this.state = {check:0,
        intialVal:"Change print roll now?"
    };
  }
  render() {
    return (
      <Container fluid style={{ padding: 0, margin: 0, alignItems: "center" }}>
        <ModalBody>
          <h5 style={{ margin: 10 }}> {this.state.intialVal}</h5>
        </ModalBody>
        <ModalFooter>
          <div>
            <Button
              color="success"
              onClick={() => {
                if(this.state.check === 0){
                    this.setState({intialVal:"Confirm once again you changed print roll?",check:1});
                }else{
                    this.props.toggleStoreStatus()
                    this.props.goBack();
                    
                }
              }}
            >
              Confirm
            </Button>{" "}
            <Button
              color="danger"
              style={{paddingLeft:25,paddingRight:25}}
              onClick={() => {
                this.props.goBack();
              }}
            >
              No
            </Button>
          </div>
        </ModalFooter>
      </Container>
    );
  }
 
  
}



// WEBPACK FOOTER //
// ./src/components/DetailedOrderCard/ConfirmPrintRoll.js